// Libellés lisibles des produits dans les phrases du lot 3 : nom du catalogue (code à défaut, soulignés remplacés)
// et préposition élidée devant une voyelle (« 9 000 L d’essence super », « 12 000 L de gasoil »).

import { PRODUITS_INITIAUX } from '../constantes';

/** Nom du produit en bas de casse, d'après le catalogue initial ; le code lisible à défaut. */
export function nomProduitLisible(code: string): string {
  return (PRODUITS_INITIAUX.find((p) => p.code === code)?.nom ?? code.replace(/_/g, ' ')).toLowerCase();
}

/** « de gasoil », « d’essence super » : la préposition s'élide devant une voyelle ou un h muet. */
export function deProduit(code: string): string {
  const nom = nomProduitLisible(code);
  return /^[aeéèêiouyh]/i.test(nom) ? `d’${nom}` : `de ${nom}`;
}
